module.exports = __webpack_public_path__ + "static/img/neumaticos.740d713.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/neumaticos.jpg
// module id = 1SO+
// module chunks = 1